<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-20 22:18:35
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-08-18 14:12:45
 * @FilePath: /jy-dashboard-web/src/components/productionManagement/cywl/component-tqtr.vue
 * @Description: 描述
-->
<template>
  <div class="subtitle">
    <span
      :class="{ unselect: subtitle !== '天气指数' }"
      style="margin-right: 14px"
      @click="selectSubtitle('天气指数')"
      >天气指数</span
    >
    <span
      :class="{ unselect: subtitle !== '土壤环境' }"
      @click="selectSubtitle('土壤环境')"
      >土壤环境</span
    >
  </div>
  <div class="trhj" id="trhj" v-if="subtitle === '土壤环境'"></div>
  <div class="tqzs" v-if="subtitle === '天气指数'">
    <el-row>
      <!-- <el-col
        class="zb"
        :style="{
          'background-image': `url(/image/production-management/icon/天气指数/${item.name}@2x.png)`,
        }"
        :span="8"
        v-for="(item, index) in tqzs"
        :key="index"
      >
        <div class="zbz">
          <span class="value">{{ item.value }}</span>
          <span class="unit">{{ item.unit }}</span>
        </div>
        <div class="zblb">
          <span class="name">{{ item.name }}</span>
        </div>
      </el-col> -->
      <template v-for="(item, index) in sbxx" :key="index">
        <el-col
          class="zb"
          :style="{
            'background-image': `url(/image/production-management/icon/天气指数/${item.device_name}@2x.png)`,
          }"
          :span="8"
          v-if="item.device_name!=='风向01'"
        >
          <div class="zbz">
            <span class="value">{{ item.value }}</span>
            <span class="unit">{{ item.unit }}</span>
          </div>
          <div class="zblb">
            <span class="name">{{ item.device_name.split('01')[0] }}</span>
          </div>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
import { Chart } from '@antv/g2'
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      // subtitle: '土壤环境',
      subtitle: '天气指数',
      chart: ''
    }
  },
  computed: {
    // ...mapState('production-management', ['loading', 'cywl', 'tqzs', 'trhj'])
    ...mapState('production-management', ['loading', 'cywl', 'sbxx', 'trhj'])
  },
  watch: {
    trhj () {
      // this.initChart()
      this.$nextTick(() => {
        this.initChart()
      })
    }
  },
  methods: {
    // ...mapActions('production-management', ['getTQZS', 'getTRHJ']),
    ...mapActions('production-management', ['getSBXX', 'getTRHJ']),
    selectSubtitle (value) {
      if (value === '土壤环境' && this.subtitle !== '土壤环境') {
        this.subtitle = '土壤环境'
        this.getTRHJ()
      }
      if (value === '天气指数' && this.subtitle !== '天气指数') {
        this.subtitle = '天气指数'
      }
    },
    initChart () {
      this.chart = new Chart({
        container: 'trhj',
        autoFit: true,
        padding: [10, 16, 10, 0]
      })
      this.chart.data(this.trhj)
      this.chart.legend(false)
      this.chart.tooltip(false)

      this.chart.scale('value', {
        min: 0,
        max: 100
      })
      this.chart.coordinate('polar', {
        radius: 0.8
      })
      this.chart.axis('name', {
        line: null,
        tickLine: null,
        label: {
          style: {
            fill: '#A8E4E5',
            fontSize: 18
          }
        },
        grid: {
          line: {
            style: {
              lineDash: null
            }
          }
        }
      })
      this.chart.axis('value', {
        line: null,
        tickLine: null,
        label: null,
        grid: {
          line: {
            type: 'line',
            style: {
              lineDash: null
            }
          }
        }
      })

      this.chart
        .line()
        .position('name*value')
        .color('#62DBED')
        .size(2)

      this.chart
        .point()
        .position('name*value')
        .color('#62DBED')
        .shape('circle')
        .size(4)
        .style({
          stroke: '#FFFFFF',
          lineWidth: 1,
          fillOpacity: 1
        })

      this.chart
        .area()
        .position('name*value')
        .color('#5BFAFD')

      this.chart.render()
    }
  },
  created () {
    // this.getTQZS()
    this.getSBXX(1585371)
  }
}
</script>

<style lang="scss">
.subtitle {
  cursor: pointer;
}
.trhj {
  margin-top: 19px;
  height: 195px;
}
.tqzs {
  margin-top: 19px;
  height: 195px;
  .zb {
    height: 96.5px;
    margin-bottom: 10px;
    position: relative;
    background-repeat: no-repeat;
    background-position: center top;
    .zblb {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
      .name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .zbz {
      position: absolute;
      left: 0;
      top: 22px;
      width: 100%;
      text-align: center;
      .value {
        // font-size: 18px;
        font-size: 14px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #edfeff;
      }
      .unit {
        // font-size: 14px;
        font-size: 12px;
        font-family: Bahnschrift;
        font-weight: 400;
        color: #d0e0e1;
      }
    }
  }
}
</style>
